import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  reservationData: {},
  loading: false,
  error: null,
};

const reservationAnalyticsSlice = createSlice({
  name: "reservationAnalytics",
  initialState,
  reducers: {
    fetchReservationAnalyticsSuccess: (state, action) => {
      state.loading = false;
      state.reservationData = action.payload;
    },
    fetchReservationAnalyticsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchReservationAnalyticsSuccess,
  fetchReservationAnalyticsFailure,
} = reservationAnalyticsSlice.actions;

export default reservationAnalyticsSlice.reducer;
